var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "44",
        "height": "44",
        "viewBox": "0 0 88 88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "-29.875%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColotBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "fill": "url(#a)",
        "cx": "44",
        "cy": "44",
        "r": "44"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('g', {
      attrs: {
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M43.69 32.008c1.57 0 15.692 6.276 15.692 7.845 0 1.57-14.122 7.846-15.691 7.846-1.57 0-15.691-6.277-15.691-7.846s14.122-7.845 15.69-7.845z"
      }
    }), _c('path', {
      attrs: {
        "d": "M56.99 47.55l1.645 1.643-2.242 2.167-2.241-2.167L55.72 47.7v-6.351h1.195v6.201h.075zm-22.34-.524c3.81 1.794 7.995 3.437 8.817 3.437.822 0 5.006-1.643 8.817-3.437h.298a.67.67 0 01.673.673v8.368c-3.213 2.018-6.5 3.064-9.713 3.064-3.213 0-6.501-1.046-9.714-3.064V47.7a.67.67 0 01.673-.673h.149z"
      }
    })])])]));
  }
};